import { render, staticRenderFns } from "./QuestionField.vue?vue&type=template&id=3de9ab54&"
import script from "./QuestionField.vue?vue&type=script&lang=ts&"
export * from "./QuestionField.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionField.vue?vue&type=style&index=0&id=3de9ab54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports